import React , { useEffect, useState,Component} from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";


const LoginFun=(props) =>{
    const navigation = useNavigate();
    const {isAuthenticated,setIsAuthenticated,Authenticated}=props;
  
    return <Login {...props} navigation={navigation} />;
  }
  
  export default LoginFun